async function ConfigurationSave(configid, oilerid, oilid, customerblanknum, length, width, speed, coverage, numofblanks, oiltemp, asshipped) {

    if (true) {

        let response;

        let params = {
            "@ConfigID": configid,
            "@OilerID": oilerid,
            "@OilID": oilid,
            "@CustomerBlankNum": customerblanknum,
            "@Length": length,
            "@Width": width,
            "@Speed": speed,
            "@Coverage": coverage,
            "@NumOfBlanks": numofblanks,
            "@OilTemp": oiltemp,
            "@AsShipped": asshipped
        };

        response = await fetch("https://api.cssi.co/query", {
            method: "POST",
            body: JSON.stringify({
                "sp": "97",
                "parameters": params,
                "servername": "Compass-Svr3\\EXACTSQLEXPRESS",
                "databasename": "WebApps",
                "continuingfunction": null,
                "noresults": false,
                "args": null
            })
        })
            .then(response => {
                return response.json();
            })
            .catch(e => {
                e.name === "AbortError" ? console.log("Fetch Aborted") : console.log(e.message);
            })

        return Promise.resolve(response);

    }
}

export default ConfigurationSave;